import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import { PATH } from '../../../../constants/path';
import { STATIC_ROOT } from '../../../../constants';
import { MOMENTJS_DATE_FORMAT, MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';

import { fetchContactRequestReasonIfNeeded } from '../../../../services/contactrequest/actions';
import { fetchAccountMessagesIfNeeded } from '../../../../services/account/mymessages/actions';

import { toDate } from '../../../../utils/dateUtils';

import SvgComponent from '../../../SvgComponent';
import HeadComponent from '../../../HeadComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

import { MyMessagePageContainer } from './MyMessagesPageStyle';

const ICON_VALIDATED = 'valide';
const ICON_WAITING = 'attente';

const renderIcon = (icon, width, height) => (
    <SvgComponent src={`${STATIC_ROOT}/icon/picto-${icon}.svg`} width={width} height={height} />
);

const renderMessageState = (icon, text, width, height) => (
    <div className="message-caption-block center-mobile">
        {renderIcon(icon, width, height)}
        <p className="hide-mobile">{text}</p>
    </div>
);

export class MyMessagesPage extends React.Component {
    renderConditionnalOnMessageState(state) {
        if (!state) return null;

        const { i18n } = this.props;
        if (state.id === 3) {
            return renderMessageState(ICON_VALIDATED, i18n.MESSAGES_CAPTION.DONE, 20, 15);
        } else {
            return renderMessageState(ICON_WAITING, i18n.MESSAGES_CAPTION.WAITING, 20, 24);
        }
    }

    renderConditionnalOnAnswerDate(answerDate) {
        if (!answerDate) return null;
        if (answerDate > 0) {
            return toDate(answerDate, MOMENTJS_DATE_FORMAT);
        }
    }

    renderContactRequestReasonLabel(id) {
        const { UNDEFINED } = this.props.common;
        const reason = this.props.contactrequestreasons.find(e => e.id === id);
        if (isEmpty(reason)) return UNDEFINED;
        return reason.label;
    }

    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
        this.props.fetchAccountMessagesIfNeeded();
    }

    render() {
        const { i18n, data, fetching } = this.props;
        return (
            <MyMessagePageContainer className="container">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_MESSAGES_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h3>{i18n.PAGE_TITLE}</h3>
                <table>
                    <thead>
                        <MediaQuery query="(min-width: 769px)">
                            {matches =>
                                matches ? (
                                    <tr>
                                        <th>{i18n.MESSAGE_DATE_DESKTOP}</th>
                                        <th className="reason">{i18n.REQUEST_REASON_DESKTOP}</th>
                                        <th className="state">{i18n.REQUEST_STATE_DESKTOP}</th>
                                        <th>{i18n.DETAILS}</th>
                                    </tr>
                                ) : (
                                    <tr>
                                        <th>{i18n.MESSAGE_DATE_MOBILE}</th>
                                        <th className="reason">{i18n.REQUEST_REASON_MOBILE}</th>
                                        <th className="state">{i18n.REQUEST_STATE_MOBILE}</th>
                                        <th className="details">{i18n.DETAILS}</th>
                                    </tr>
                                )
                            }
                        </MediaQuery>
                    </thead>
                    <tbody>
                        {fetching ? (
                            <tr>
                                <MediaQuery query="(min-width: 769px)">
                                    {matches => (
                                        <td colSpan={matches ? '4' : '4'}>
                                            <LoadingComponent />
                                        </td>
                                    )}
                                </MediaQuery>
                            </tr>
                        ) : data && data.length > 0 ? (
                            map(data, message => (
                                <tr key={message.id}>
                                    <MediaQuery query="(min-width: 769px)">
                                        {matches => (
                                            <td>
                                                {matches
                                                    ? toDate(
                                                          message.requestDate,
                                                          MOMENTJS_DATE_FORMAT
                                                      )
                                                    : toDate(
                                                          message.requestDate,
                                                          MOMENTJS_DATE_FORMAT_STANDARD
                                                      )}
                                            </td>
                                        )}
                                    </MediaQuery>
                                    <td className="reason">
                                        {this.renderContactRequestReasonLabel(
                                            message.contactRequestReasonId
                                        )}
                                    </td>
                                    <td className="picto">
                                        {this.renderConditionnalOnMessageState(message.state)}
                                    </td>
                                    <td className="details">
                                        <MediaQuery query="(min-width: 769px)">
                                            {matches => (
                                                <Link
                                                    to={`${PATH.ACCOUNT_MESSAGES_PATH}/${message.id}`}>
                                                    {matches
                                                        ? i18n.SHOW_MESSAGE_DETAILS_DESKTOP
                                                        : i18n.SHOW_MESSAGE_DETAILS_MOBILE}
                                                </Link>
                                            )}
                                        </MediaQuery>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <MediaQuery query="(min-width: 769px)">
                                    {matches => (
                                        <td className="empty" colSpan={matches ? '5' : '4'}>
                                            {i18n.NO_MESSAGES}
                                        </td>
                                    )}
                                </MediaQuery>
                            </tr>
                        )}
                    </tbody>
                </table>
                <section className="message-caption">
                    <div className="message-caption-block">
                        {renderIcon(ICON_VALIDATED, 24, 18)}
                        <p>{i18n.MESSAGES_CAPTION.DONE}</p>
                    </div>
                    <div className="message-caption-block">
                        {renderIcon(ICON_WAITING, 24, 24)}
                        <p>{i18n.MESSAGES_CAPTION.WAITING}</p>
                    </div>
                </section>
                <section className="message-bottom">
                    {i18n.FOOTER_TEXT}
                    <Link to={PATH.FAQ_PATH}>FAQ</Link> ?&nbsp;
                    <Link to={PATH.CONTACTREQUEST_PATH}>{i18n.CONTACT_CUSTOMER_SERVICE}</Link>.
                </section>
            </MyMessagePageContainer>
        );
    }
}

MyMessagesPage.propTypes = {
    common: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    contactrequestreasons: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        common: state.i18n.common,
        i18n: state.i18n.page.ACCOUNT.MESSAGES,
        data: state.account.mymessages.messages || [],
        fetching: state.account.mymessages.fetching,
        contactrequestreasons: state.contactrequest
            ? state.contactrequest.contactrequestreasons
            : []
    };
}

const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded,
    fetchAccountMessagesIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMessagesPage);



// WEBPACK FOOTER //
// ./src/components/pages/account/mymessages/MyMessagesPage.js